<let/isVisible=input.showAlert>

<if=isVisible>
  <div class="label alert-bar w-full py-2 flex items-center justify-between bg-nasa-deep text-white px-4">
    <div class="flex-1 text-center">$!{input.alertText}</div>
    <button
      class="label text-white/80 border-none px-2"
      onClick() { isVisible = false }
    >Close</button>
  </div>
</if>

<style>
  .alert-bar a { color: #ffffff; }
</style>
